import { SuggestAPartnershipButton } from 'app/src/shared/components/SuggestAPartnershipButton'
import { Card } from 'primereact/card'
import type { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

export function SuggestAPartnershipSection(): ReactElement {
  const { t } = useTranslation('catalog')

  return (
    <div className='grid'>
      <Card title={t('Catalog.SuggestAPartnership.Title')} className=''>
        <p className='m-0'>{t('Catalog.SuggestAPartnership.Text')}</p>
        <div className='float-right'>
          <SuggestAPartnershipButton />
        </div>
      </Card>
    </div>
  )
}
